import Stack from '@mediahuis/chameleon-react/dist/es/components/Stack';
import StackItem from '@mediahuis/chameleon-react/dist/es/components/Stack/StackItem';
import Paragraph from '@mediahuis/chameleon-react/dist/es/components/Paragraph';
import Heading from '@mediahuis/chameleon-react/dist/es/components/Heading';
import Button from '@mediahuis/chameleon-react/dist/es/components/Button';
import LinkText from '@mediahuis/chameleon-react/dist/es/components/LinkText';
import { ChevronForward } from '@mediahuis/chameleon-theme-wl/icons';
import { renderToStaticMarkup } from 'react-dom/server';
import { ReactNode } from 'react';

export type Slots = {
  title: ReactNode;
  content: ReactNode;
  callToAction: ReactNode;
};

type LoginWallProps = {
  searchParams: string;
} & Slots;

function LoginWall({ searchParams, title, content, callToAction }: LoginWallProps) {
  return (
    <Stack gap={8} style={{ background: '#FAFAFA', padding: 'var(--scale-10)' }}>
      <StackItem>
        <Stack gap={5}>
          <StackItem>
            <Heading style={{ marginTop: 0, marginBottom: 0 }}>{title}</Heading>
          </StackItem>
          <StackItem>
            <Paragraph size="lg">{content}</Paragraph>
          </StackItem>
        </Stack>
      </StackItem>
      <StackItem>
        <Stack gap={2}>
          <StackItem>
            <Button
              as="a"
              href={`/auth/login?${searchParams}`}
              appearance="primary"
              width="full"
              iconRight={ChevronForward}
              data-login
              data-testid="login-btn-inline"
            >
              {callToAction}
            </Button>
          </StackItem>
          <StackItem>
            <Paragraph style={{ textAlign: 'center' }} weight="strong">
              Nog geen account?{' '}
              <LinkText data-register href={`/auth/register?${searchParams}`} data-testid="register-link-inline">
                Maak een account aan.
              </LinkText>
            </Paragraph>
          </StackItem>
        </Stack>
      </StackItem>
    </Stack>
  );
}

export function generate({ searchParams, title, content, callToAction }: LoginWallProps) {
  return {
    html: renderToStaticMarkup(
      <LoginWall searchParams={searchParams} callToAction={callToAction} content={content} title={title} key={Date.now()} />,
    ),
    css: '',
  };
}
